import axios from "axios";
import * as config from '../../config/envConfig';
import { isRelocationDateAfterNewChanges } from "../utilities";

const contentTypes = {
  json: "application/json"
};

const responseTypes = {
  json: "json"
};
const func = [
  function (data) {
    return data;
  }
];

// API request encapsulation
const request = async (path,
  method,
  data,
  cType,
  rType,
  anotherPath,
  header) => {
  const contentType = (cType === undefined  || cType === null) ? contentTypes.json : cType;
  const responseType = (rType === undefined || rType === null) ? responseTypes.json : rType;
  const httpMethod = method || "get";
  let utoken = await getUserToken();
  const headerConfig =
    header === undefined
      ? { Authorization: `Bearer ${utoken}` }
      : { "Auth-Token": `${utoken}` };
  return await axios({
    method: httpMethod,
    data,
    url: anotherPath === undefined ? config.PROXY_URL + path : path,
    headers: {
      "Content-Type": `${contentType}`,
      ...headerConfig
    },
    responseType: responseType,
    transformRequest: anotherPath ? func : null
  })
    .then(result => {
      return result.data;
    })
    .catch(error => {
      if (error.response) {
        throw error.response.data;
      } else {
        throw error.message;
      }
    });
};

function getUrl(BasicUrl, path, endpoint) {
  if (endpoint) {
    return path;
  }
  return `${BasicUrl}${path}`;
}

const getFormData = object => {
  if (typeof (FormData) === undefined) {
    const data = [];
    Object.keys(object).forEach(key => {
      Object.values(object).forEach(val => {
        data.push(key, JSON.stringify(val));
      });
    });
    return data;
  } else {
    return Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
  }
};
/**
 *
 * @param {string} targetValue
 * @param {string} targetValue
 */
// get the qas data
const getAddress = targetValue => {
const uri = config.QAS;
  const requestData =
  {
    "qasType": "search",
    "search": targetValue
  }
  return request(
    uri,
    "post",
    JSON.stringify(requestData),
    undefined,
    undefined,
    true
  ).then(PicklistEntry => {
    const results = PicklistEntry.qaSearchResult.qaPicklist.picklistEntry;
    const PartialAddress = results[0].moniker === ""
      ? results[0].picklist
      : results.map(address => address.partialAddress)
    return { PicklistEntry: results, PartialAddress: PartialAddress }
  }).catch(err => {
  })
};

const getBsbDetails = (value) => {
  const url = "api/ReferenceDataService/RetrieveBSBDetails";
  const content = { BSBNumber: value };
  return request(url, "post", content).then(res => {
    if (res.Successful) {
      return {
        bsbName: res.BSBLookUpDetails[0].BranchName,
        bankName: res.BSBLookUpDetails[0].BankName,
        isSuccessful: res.Successful
      };
    } else {
      return {
        isSuccessful: res.Successful
      }
    }
  });
}

const getUserToken = () => {
  let expires_on = sessionStorage.getItem("expires_on");
  let refresh_token = sessionStorage.getItem("refresh_token");
  // check user access token expiry if expired call refresh token

  if ((new Date().toISOString() >= new Date(expires_on * 1000).toISOString()) &&
    (refresh_token !== null && refresh_token !== undefined && refresh_token !== "")) {

    let param = {
      tokenType: "refresh_token",
      refreshToken: refresh_token
    }

    axios({
      url: config.TWS_LOGIN,
      method: "post",
      ContentType: "multipart/form-data",
      data: param
    }).then(
      function (response) {
        if (response.data.access_token !== undefined && response.data.access_token !== null && response.data.access_token !== "") {
          sessionStorage.setItem("login_access_token", response.data.access_token);
          sessionStorage.setItem("expires_on", response.data.expires_on);
          sessionStorage.setItem("refresh_token", response.data.refresh_token);
        }
      })
  }
  return sessionStorage.getItem("login_access_token");
};

const isNewAfrByRequiredDate = async () => {
  const relocationPlanID = sessionStorage.getItem('RelocationPlanId');
  const url = `api/OrderDetailService/RetrieveRelocationPlanRelocationDetails`;
  const content = { "Id": relocationPlanID };

  const res = await request(url, "post", content);
  if (res.Successful) {
    const relocationRequiredDate = new Date(res.RelocationDetails.RelocationRequiredDate);
    //separation
    const relocationSeparation=res.RelocationDetails.ReasonForRelocationSubTypeDescription;
    const isNewAfr = isRelocationDateAfterNewChanges(relocationRequiredDate);
    if(relocationSeparation.toLowerCase() ==='separation'){
     return { isNewAfrSep:true, isNewAfr:false };
    }
    return { isNewAfr: isNewAfr,isNewAfrSep:false };
  } else {
    return { isNewAfr: true,isNewAfrSep:false };
  }
}

export default {
  contentTypes,
  responseTypes,
  request,
  getUrl,
  getFormData,
  getAddress,
  getBsbDetails,
  getUserToken,
  isNewAfrByRequiredDate
};
